import React from "react"
import Constants from "../utils/constants";
import styled from "@emotion/styled";

export default function Logo() {
    return (
        <LogoWrapper>
            <img src={Constants.ASSETS.APP_LOGO.PATH} alt={Constants.ASSETS.APP_LOGO.ALT_TEXT} className="logo" />
        </LogoWrapper>
    )
}

export const LogoWrapper = styled.div`
  .logo {
    padding-bottom: 40px;
    height: 157px;
  }
`;
